import React from 'react';
import PropTypes from 'prop-types';
import './ActivityItem.css';

function ActivityItem({ 
  type = 'event', // 'event', 'organizer', 'dataChange', 'report', 'messageReport'
  dateTime, 
  title, 
  subtitle,
  badgeText,
  badgeType,
  isDeactivation = false,
  isActivation = false,
  onClick 
}) {
  // Color mapping based on type
  const colorMap = {
    event: '#EE8F3B',      // Orange
    organizer: '#7D959F',  // Teal/Morski-light
    dataChange: '#201E25', // Dark
    report: '#DD2626',     // Red
    messageReport: '#8B1E3F',
  };

  const indicatorColor = isDeactivation
    ? '#DD2626'
    : isActivation
    ? '#059669'
    : (colorMap[type] || colorMap.event);

  const itemClassName = [
    'activity-item',
    isDeactivation ? 'activity-item--deactivation' : '',
    isActivation ? 'activity-item--activation' : '',
  ].filter(Boolean).join(' ');

  const resolvedBadgeType = badgeType || (isDeactivation ? 'danger' : isActivation ? 'success' : 'default');

  const subtitleClassName = [
    'activity-item__subtitle',
    isDeactivation ? 'activity-item__subtitle--danger' : '',
    isActivation ? 'activity-item__subtitle--success' : '',
  ].filter(Boolean).join(' ');

  return (
    <div className={itemClassName} onClick={onClick}>
      <div 
        className="activity-item__indicator" 
        style={{ backgroundColor: indicatorColor }}
      />
      <div className="activity-item__content">
        <div className="activity-item__header-row">
          <span className="activity-item__datetime">{dateTime}</span>
          {badgeText && (
            <span className={`activity-item__badge activity-item__badge--${resolvedBadgeType}`}>
              {badgeText}
            </span>
          )}
        </div>
        <span className="activity-item__title" title={title}>{title}</span>
        {subtitle && (
          <span className={subtitleClassName}>
            {subtitle}
          </span>
        )}
      </div>
      <div className="activity-item__arrow">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.91 19.92L15.43 13.4C16.2 12.63 16.2 11.37 15.43 10.6L8.91 4.08" stroke="#7E7E7E" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
    </div>
  );
}

ActivityItem.propTypes = {
  type: PropTypes.oneOf(['event', 'organizer', 'dataChange', 'report', 'messageReport']),
  dateTime: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  badgeText: PropTypes.string,
  badgeType: PropTypes.string,
  isDeactivation: PropTypes.bool,
  isActivation: PropTypes.bool,
  onClick: PropTypes.func,
};

ActivityItem.defaultProps = {
  type: 'event',
  subtitle: null,
  badgeText: null,
  badgeType: null,
  isDeactivation: false,
  isActivation: false,
  onClick: () => {},
};

export default ActivityItem;

